<template>
<!-- Remember to include jQuery :) -->

  <div class="hello">

				   <div style="text-align: center;">
<!-- <script language="JavaScript">


</script> -->




<div id="count"><template v-if="new Date() > 1652403600000">선물하기 기능이 오픈되었습니다!</template><template v-else>선물하기 오픈까지 
	<span style="font-size: 24px; font-weight: 600; color: #f3ae03;" id="counter1">{{ timer.hour }}</span>시간<span id="counter2" style="font-size: 24px; font-weight: 600; color: #f3ae03;">{{ timer.minute }}</span>분<span id="counter3" style="font-size: 24px; font-weight: 600; color: #f3ae03;">{{ timer.second }}</span>초 남았습니다.</template><span style="padding-left:30px;"></span></div>



<!-- <script>getTime()</script>					    -->
					   
		<img src="../assets/img/gift_comingsoon.png">	 
						   </div>
		
<div style="clear: both"></div>

<div style="text-align:center;" v-if="new Date() > 1652403600000"><router-link to="/giftshop/hair/1"><button type="button" class="btn btn-warning btn-lg">바로가기</button></router-link></div>
		  </div>

  
</template>

<script>
import axios from 'axios';
export default {
  name: 'home',
  methods: {
},
  mounted(){
    

setInterval(() => {

var remainTime = (1652403600000 - new Date()) / 1000

let days = remainTime  / 60 / 60 / 24; 
let daysRound = Math.floor(days); 
let hours = remainTime / 60 / 60 - (24 * daysRound); 
let hoursRound = Math.floor(hours); 
let minutes = remainTime /60 - (24 * 60 * daysRound) - (60 * hoursRound); 
let minutesRound = Math.floor(minutes); 
let seconds = remainTime - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound); 
let secondsRound = Math.round(seconds);

this.timer.hour = hoursRound;
this.timer.minute = minutesRound;
this.timer.second = secondsRound;


}, 1000)

},

data(){
  return {
    timer: {
        hour: 0,
        minute: 0,
        second: 0
    },
    time: 0
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/*타임*/
#count {
 height: 147px;
 color: #fff;
 
 padding-top:60px;
 background-repeat: no-repeat;
}
#bt {
 height: 16px;
 width: 49;
 padding-left: 100px;
 padding-top: 0px;
}
</style>
